import { get } from 'helpers/api';

const rootPath = '/lease_spaces';

export function searchLeaseSpaces(searchTerm, projectIds, onSuccess) {
  const query = 'q[address2_cont]';
  get(`${rootPath}/lease_search.json`, { params: { projectIds: projectIds, [query]: searchTerm } })
    .then(function (response) {
      onSuccess(response.leaseSpaces);
    });
}

